enum userModes {
    CUSTOMER,
    ADVISOR,
}

export default userModes